import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { ChannelMessaging, MessageModel, UsersInChannel } from '../../helper/multiuserMessaging';

@Injectable({
  providedIn: 'root'
})
export class ChannelMessagingService {
  environment = EnvironmentService.environment;

  constructor(public http: HttpClient) { }

  public GetUsersDetails() {
    return this.http.get(`${this.environment.messagingUrl}/GetApplicationUser`).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  public CreateChannelMessaging(channelMessaging: ChannelMessaging) {
    return this.http.post<ChannelMessaging>(
      `${this.environment.createChannelUrl}/Add`,
      channelMessaging
    );
  }
  public GetChannelList() {
    return this.http
      .get(`${this.environment.createChannelUrl}/GetChannelsByChannelOwner`)
      .pipe(
        map((channelList: any) => {
          return channelList;
        })
      );
  }
  public MarkChannelMessagesRead(channelId: any) {
    return this.http
      .put(`${this.environment.channelMessage}/MarkChannelMessagesRead?chennelId=${channelId}`, null)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  public GetChannelByChannelId(channelId: any) {
    return this.http
      .get(
        `${this.environment.createChannelUrl}/GetChannelByChannelId?channelId=${channelId}`
      )
      .pipe(
        map((channelDetails: any) => {
          return channelDetails;
        })
      );
  }

  public UpdateChannelDetails(channelMessagingModel: ChannelMessaging) {
    return this.http.put<ChannelMessaging>(
      `${this.environment.createChannelUrl}/Update`,
      channelMessagingModel
    );
  }
  public DeleteChannelRecord(channelId: number) {
    return this.http
      .delete(`${this.environment.createChannelUrl}/delete?channelId=${channelId}`)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  public LeaveChannelUser(userLeaveChannel: UsersInChannel) {
    return this.http
      .put<UsersInChannel>(
        `${this.environment.createChannelUrl}/LeaveChannel`,
        userLeaveChannel
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  public GetAllChannelMessage(channelId: any, currentPage: number, pageSize: number) {
    return this.http
      .get(
        `${this.environment.channelMessage}/GetAllChannelMessageByChannelId?ChannelId=${channelId}&currentPage=${currentPage}&pageSize=${pageSize}`
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
  public GetUnreadChannelMessagesCount(channelId: number) {
    return this.http
      .get(
        `${this.environment.channelMessage}/GetUnreadChannelMessagesCount?chennelId=${channelId}`
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
  public SendMessage(messageModel: any) {
    return this.http
      .post<MessageModel>(`${this.environment.channelMessage}/Add`, messageModel)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
  public UpdateMessage(messageModel: MessageModel) {
    return this.http
      .put<MessageModel>(`${this.environment.channelMessage}/Update`, messageModel)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
  public DeleteMessage(channelMessageId: number) {
    return this.http
      .delete(
        `${this.environment.channelMessage}/Delete?ChannelMessagId=${channelMessageId}`
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
}
